import { RQ_PARAMETER_BY_ID } from '@brighterion/utils/react-query-constants';
import { useQuery } from '@tanstack/react-query';
import { getParameterById } from 'Services';

const useGetParameterById = (id: string) => {
    return useQuery([RQ_PARAMETER_BY_ID, id], () => getParameterById(id), {
        select: (data) => data,
        cacheTime: 0
    });
};

export default useGetParameterById;
